import React from 'react';

const CodingPython: React.FC = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        Kompetisi <b>Coding Python</b> di ajang <b>Indonesia Innovative Technology Challenge (IIT Challenge) 2024</b> menjadi salah satu kategori yang paling diminati oleh peserta.
      </p>
      
      <p className="mb-6">
        Bagi para peserta, kompetisi ini bukan sekadar lomba, melainkan kesempatan untuk mengasah kemampuan berpikir logis, menyelesaikan masalah, dan menerapkan konsep coding secara praktis.
      </p>
      
      <h2 className="text-2xl font-bold mb-4">Tantangan dalam Coding Python</h2>
      <p className="mb-4">
        Kompetisi ini dirancang dengan tingkat kesulitan yang sesuai untuk pelajar, namun tetap menantang:
      </p>
      
      <ol className="list-decimal pl-6 mb-6 space-y-4">
        <li>
          <p><strong>Logika dan Algoritma</strong></p>
          <p>
            Peserta diuji kemampuannya dalam memahami masalah dan menerapkan logika pemrograman untuk menemukan solusi.
          </p>
        </li>
        <li>
          <p><strong>Pemecahan Masalah</strong></p>
          <p>
            Setiap soal yang diberikan menuntut peserta untuk mengembangkan solusi efisien menggunakan Python, seperti memanipulasi data, membuat perhitungan matematika, hingga mengatur alur program.
          </p>
        </li>
      </ol>
      
      <h2 className="text-2xl font-bold mb-4">Manfaat Kompetisi Coding Python</h2>
      
      <ol className="list-decimal pl-6 mb-6 space-y-4">
        <li>
          <p><strong>Meningkatkan Keterampilan Teknologi</strong></p>
          <p>
            Peserta dapat memperdalam kemampuan mereka dalam menggunakan Python, salah satu bahasa pemrograman paling populer saat ini.
          </p>
        </li>
        <li>
          <p><strong>Belajar Bersaing Secara Positif</strong></p>
          <p>
            Kompetisi ini mengajarkan peserta pentingnya bekerja keras, bersikap sportif, dan bersosialisasi.
          </p>
        </li>
        <li>
          <p><strong>Menyiapkan Generasi Digital</strong></p>
          <p>
            Dengan mengikuti kompetisi seperti ini, para pelajar dipersiapkan untuk menjadi bagian dari generasi yang mampu memanfaatkan teknologi untuk memecahkan masalah di dunia nyata.
          </p>
        </li>
      </ol>
      
      <h2 className="text-2xl font-bold mb-4">Kesempatan Baru di Dunia Pemrograman</h2>
      <p className="mb-4">
        Kompetisi Coding Python di IIT Challenge 2024 menjadi salah satu bukti bahwa generasi muda Indonesia memiliki potensi luar biasa dalam teknologi. Acara ini tidak hanya melatih keterampilan coding, tetapi juga membangun kepercayaan diri untuk terus belajar dan berkembang.
      </p>
      
      <h2 className="text-2xl font-bold mb-4">Lihat Keseruannya di Instagram</h2>
      <p className="mb-4">
        Untuk informasi lebih lanjut dan momen seru lainnya dari IIT Challenge 2024, kunjungi Instagram kami di <a href="https://instagram.com/iitchallenge2024" target='_blank' className="underline font-semibold text-defaultBlue">@iitchallenge2024</a>.
      </p>
      
      <p>
        Temukan inspirasi dari karya-karya luar biasa generasi muda Indonesia dan persiapkan dirimu untuk tantangan selanjutnya!
      </p>
    </div>
  );
};

export default CodingPython;